<template>
  <div class="eu-px_3 eu-pb_5">
    <PixFirstTransaction
      v-if="!!firstTransaction.qr_code_url"
      :charge-id="chargeId"
      :qr-code-url="firstTransaction.qr_code_url"
    />
    <div v-else>-</div>

    <div class="eu-mt_4">
      <p class="emd-text _color_default _type_caption eu-mb_1">
        {{ $t('charge.detail.payment-method.pix.expire-at') }}
      </p>
      <p>{{ firstTransaction.expires_at | dateFormat('date') }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChargesPaymentMethodPix',

  components: {
    PixFirstTransaction: () => import('./PixFirstTransaction.vue')
  },

  props: {
    transactions: {
      required: true
    },
    chargeId: {
      required: true
    }
  },

  data () {
    return {
      copyQrCode: false,
      pixModalOpen: false,
      debounceTimer: undefined
    }
  },

  computed: {
    firstTransaction () {
      return this.transactions[this.transactions.length - 1]
    }
  },

  methods: {
    togglePixModal () {
      this.pixModalOpen = !this.pixModalOpen
    },
    copyToClipboard (value) {
      this.$copyText(value).then(() => {
        this.copyQrCode = true
        clearTimeout(this.debounceTimer)
        this.debounceTimer = setTimeout(() => {
          this.copyQrCode = false
        }, 1000)
      })
    }
  }
}
</script>
